// import { differenceInCalendarDays } from 'date-fns';
import Cookies from 'js-cookie';

import axios from './_defaults/api';

import { uploadImage } from './images';

export async function getUser() {
    const userId = Cookies.get('user-id');
    const response = await axios.get(`/users/profiles/${userId}`);

    if (response.data) {
        return response.data
    }

    return response
}

export async function updateUser({data}) {
    const userId = Cookies.get('user-id');
    const response = await axios.post(`/users/profiles/${userId}`, data);

    if(response.data) {
        return response.data
    }

    return response
}

export async function updateUserImage({activityId, file}) {
    try {
        const {key} = await uploadImage({ activityId, file, params: {type: "USER_AVATAR"} });
        await updateUser({ data: { "image.url": key } });
        return key;
    } catch (error) {
        console.log(error);
        throw error;
    }
}